import Icon from './assets/icon-compare.svg';
import {Menu} from './Menu';
import {ButtonContainer} from './StyledComponents';

interface IProps {
  open: boolean;
  onMenuIconClick: () => void;
}

export const CompareAreaButton = ({open, onMenuIconClick}: IProps) => {
  return (
    <ButtonContainer>
      <Menu
        icon={Icon}
        active={open}
        label="상권비교"
        onClick={onMenuIconClick}
      />
    </ButtonContainer>
  );
};
